<template>
  <div class="order-list">
    <el-card class="query-card">
      <el-form :model="MerBankAccount" ref="queryForm" label-width="auto" size="small" inline>

        <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
          <el-form-item
            :label="$t('MerBankAccount.mbaBankaccount')"
            prop="mbaBankaccount"
          >
            <div class="input-with-more">
              <el-input v-model="MerBankAccount.mbaBankaccount" :placeholder="$t('MerBankAccount.mbaBankaccount')" clearable />
            </div>
          </el-form-item>
        </el-col>



        <el-col :xs="24"
                :sm="12"
                :md="12"
                :lg="{span:8,offset:8}"
                :xl="{span:6,offset:12}">
          <el-form-item
            :label="$t('MerBankAccount.mbaStatus')"
            prop="status"
            label-width="auto"
          >
            <el-select
              v-model="MerBankAccount.mbaStatus"
              :placeholder="$t('MerBankAccount.mbaStatus')"
              clearable
              filterable
              style="width: 100%;"
            >
              <el-option
                :label="$t('MerBankAccount.mbaStatus_0')"
                value="0"
              />

              <el-option
                :label="$t('MerBankAccount.mbaStatus_1')"
                value="1"
              />

              <el-option
                :label="$t('MerBankAccount.mbaStatus_2')"
                value="2"
              />

              <el-option
                :label="$t('MerBankAccount.mbaStatus_-1')"
                value="-1"
              />

              <el-option
                :label="$t('MerBankAccount.mbaStatus_-2')"
                value="-2"
              />
            </el-select>
          </el-form-item>
        </el-col>



        <el-col :span="24">
          <el-form-item style="display: flex; justify-content: center; margin-top: 20px; margin-bottom: 20px;" label-width="0">
            <el-button type="primary" @click="handleSearch">{{ $t('query') }}</el-button>
            <el-button @click="handleReset">{{ $t('reset') }}</el-button>
          </el-form-item>
        </el-col>


      </el-form>
    </el-card>

    <div class="action-toolbar">

      <el-button
        v-if="hasPermission('merchant/showMerbankaccount', 'button_update')"
        :disabled="!hasSearched"
        :loading="updateLoading"
        @click="handleUpdate"
        type="primary"
        icon="el-icon-edit"
      >
        {{ $t('button.update') }}
      </el-button>

      <el-button
        v-if="hasPermission('merchant/showMerbankaccount', 'button_add')"
        @click="handleAdd"
        type="primary"
        icon="el-icon-plus"
      >
        {{ $t('button.add') }}
      </el-button>



      <el-button
        v-if="hasPermission('merchant/showMerbankaccount', 'button_delete')"
        @click="handleDele"
        type="danger"
        icon="el-icon-delete"
      >
        {{ $t('button.delete') }}
      </el-button>

      <el-button
        v-if="hasPermission('merchant/showMerbankaccount', 'button_check')"
        @click="handleCheck"
        type="success"
        icon="el-icon-question"
      >
        {{ $t('button.check') }}
      </el-button>

    </div>


    <el-card class="table-card" style="margin-top: 16px; overflow-x: auto;">
      <el-table :data="tableData" @sort-change="handleSortChange" border  style="width: 100%" v-loading="loading" show-overflow-tooltip
                :cell-style="{whiteSpace: 'nowrap'}"
                :header-cell-style="{whiteSpace: 'nowrap'}"
      >

        <el-table-column width="120" align="center" :label="$t('choose')">
          <template slot-scope="scope">
            <el-radio
              v-model="selectedRowId"
              :label="scope.row.mbaId"
              @change="handleRadioChange(scope.row)"
            >
              {{''}}
            </el-radio>
          </template>
        </el-table-column>
<!--        <el-table-column prop="mbaId"  label="ID" :min-width="columnWidths.mbaBankname"></el-table-column>-->

        <el-table-column prop="mbaBankname"  :label="$t('MerBankAccount.mbaBankname')" :min-width="columnWidths.mbaBankname"></el-table-column>

        <el-table-column prop="mbaBankholder" :label="$t('MerBankAccount.mbaBankholder')" :min-width="columnWidths.mbaBankholder"></el-table-column>
        <el-table-column prop="mbaBankaccount" :label="$t('MerBankAccount.mbaBankaccount')" :min-width="columnWidths.mbaBankaccount"></el-table-column>
        <el-table-column prop="mbaBandadd" :label="$t('MerBankAccount.mbaBandadd')" :min-width="columnWidths.mbaBandadd"></el-table-column>
        <el-table-column prop="mbaBankCountry" :label="$t('MerBankAccount.mbaBankCountry')" :min-width="columnWidths.mbaBankCountry"></el-table-column>
        <el-table-column prop="mbaCurrency" :label="$t('MerBankAccount.mbaCurrency')" :min-width="columnWidths.mbaCurrency"></el-table-column>

        <el-table-column :label="$t('MerBankAccount.mbaIsdefault')" :min-width="columnWidths.mbaIsdefault">
          <template slot-scope="scope">
            {{ scope.row.mbaIsdefault === '1' ? $t('MerBankAccount.yes') : $t('MerBankAccount.no') }}
          </template>
        </el-table-column>

        <el-table-column prop="mbaStatus" :label="$t('MerBankAccount.mbaStatus')" :min-width="columnWidths.mbaStatus">
          <template slot-scope="scope">
            {{ $t(`MerBankAccount.mbaStatus_${scope.row.mbaStatus}`) }}
          </template>
        </el-table-column>

        <el-table-column prop="mbaCheckUser" :label="$t('MerBankAccount.mbaCheckUser')" :min-width="columnWidths.mbaCheckUser"></el-table-column>
        <el-table-column prop="mbaCheckTime" sortable="custom" :label="$t('MerBankAccount.mbaCheckTime')" :min-width="columnWidths.mbaCheckTime"></el-table-column>
        <el-table-column prop="mbaCheckReason" :label="$t('MerBankAccount.mbaCheckReason')" :min-width="columnWidths.mbaCheckReason"></el-table-column>
        <el-table-column prop="mbaLoginName" :label="$t('MerBankAccount.loginName')" :min-width="columnWidths.loginName"></el-table-column>
        <el-table-column prop="mbaOprtime" sortable="custom" :label="$t('MerBankAccount.oprtime')" :min-width="columnWidths.oprtime"></el-table-column>
        <el-table-column prop="mbaRemark" :label="$t('MerBankAccount.remark')" :min-width="columnWidths.remark"></el-table-column>

      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.page"
        :page-sizes="[10, 20, 50]"
        :page-size="pagination.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        style="margin-top: 16px; text-align: right;"
      />
    </el-card>


    <!--  弹窗  -->
    <el-drawer
      :title="dialogTitle"
      :visible.sync="updateDialogVisible"
      :before-close="handleDrawerClose"
      direction="rtl"
      size="50%"


    >

      <el-form
        ref="form"
        :model="formData"
        label-width="120px"
        class="drawer-form"
        :rules="rules"
      >

        <el-form-item :label="$t('MerBankAccount.mbaBankname')" required prop="mbaBankname">
          <el-input v-model="formData.mbaBankname" :disabled="dialogType === 'check'"/>
        </el-form-item>

        <el-form-item :label="$t('MerBankAccount.mbaBankholder')" required prop="mbaBankholder">
          <el-input v-model="formData.mbaBankholder" :disabled="dialogType === 'check'"/>
        </el-form-item>

        <el-form-item :label="$t('MerBankAccount.mbaBankaccount')" required prop="mbaBankaccount">
          <el-input v-model="formData.mbaBankaccount" :disabled="dialogType === 'check'"/>
        </el-form-item>

        <el-form-item :label="$t('showMerbankaccount.merState')" prop="province">
          <el-input v-model="formData.province" :disabled="dialogType === 'check'"/>
        </el-form-item>

        <el-form-item :label="$t('showMerbankaccount.merCity')" prop="city">
          <el-input v-model="formData.city" :disabled="dialogType === 'check'"/>
        </el-form-item>

        <el-form-item :label="$t('MerBankAccount.mbaBandadd')" required prop="mbaBandadd">
          <el-input v-model="formData.mbaBandadd" :disabled="dialogType === 'check'"/>
        </el-form-item>

        <el-form-item :label="$t('MerBankAccount.mbaBankCountry')" required prop="mbaBankCountry">
          <el-input v-model="formData.mbaBankCountry" :disabled="dialogType === 'check'"/>
        </el-form-item>


        <el-form-item :label="$t('showMerbankaccount.mbaCurrency')" required prop="mbaCurrency">

          <el-input
            v-if="dialogType === 'check'"
            v-model="formData.mbaCurrency"
            disabled
          />

          <template v-else>

          <el-checkbox
            v-model="checkAllCurrency"
            @change="handleCheckAllCurrency"
          >
            {{$t('selectAll')}}
          </el-checkbox>

          <el-divider></el-divider>

          <el-checkbox-group v-model="formData.mbaCurrency">
            <el-row :gutter="10">
              <el-col v-for="item in currencyList" :key="item.currId" :span="6">
                <el-checkbox :label="String(item.currValue)">
                  {{ item.currName }}
                </el-checkbox>
              </el-col>
            </el-row>
          </el-checkbox-group>

        </template>

        </el-form-item>


        <el-form-item :label="$t('showMerbankaccount.mbaPayeeProperty')" required  prop="mbaPayeeProperty">
          <el-input v-model="formData.mbaPayeeProperty" :disabled="dialogType === 'check'"/>
        </el-form-item>

        <el-form-item :label="$t('showMerbankaccount.mbaPayeeAddress')" required  prop="mbaPayeeAddress">
          <el-input v-model="formData.mbaPayeeAddress" :disabled="dialogType === 'check'"/>
        </el-form-item>

        <el-form-item :label="$t('showMerbankaccount.mbaPayeeCountry')" required  prop="mbaPayeeCountry">
          <el-input v-model="formData.mbaPayeeCountry" :disabled="dialogType === 'check'"/>
        </el-form-item>

        <el-form-item :label="$t('showMerbankaccount.mbaMiddleBank')" prop="mbaMiddleBank">
          <el-input v-model="formData.mbaMiddleBank" :disabled="dialogType === 'check'"/>
        </el-form-item>

        <el-form-item :label="$t('showMerbankaccount.mbaMiddleBankcode')" prop="mbaMiddleBankcode">
          <el-input v-model="formData.mbaMiddleBankcode" :disabled="dialogType === 'check'"/>
        </el-form-item>

        <el-form-item :label="$t('showMerbankaccount.mbaSwiftCode')" required prop="mbaSwiftCode">
          <el-input v-model="formData.mbaSwiftCode" :disabled="dialogType === 'check'"/>
        </el-form-item>

        <el-form-item :label="$t('showMerbankaccount.mbaIban')" prop="mbaIban">
          <el-input v-model="formData.mbaIban" :disabled="dialogType === 'check'"/>
        </el-form-item>

        <el-form-item :label="$t('showMerbankaccount.mbaPayBank')" prop="mbaPayBank">
          <el-input v-model="formData.mbaPayBank" :disabled="dialogType === 'check'"/>
        </el-form-item>


        <el-form-item :label="$t('showMerbankaccount.remark')" prop="mbaRemark">
          <el-input
            type="textarea"
            :rows="3"
            v-model="formData.mbaRemark"
            :disabled="dialogType === 'check'"
            :placeholder="$t('showMerbankaccount.remark_fv_of')"
          />
        </el-form-item>

<!--     审核   -->
        <template v-if="dialogType === 'check'">


          <el-form-item
            :label="$t('showMerbankaccount.checkStatus')"
          >
            <el-select
              v-model="checkForm.status"
              style="width:100%"
            >
              <el-option
                :label="$t('showMerbankaccount.checkStatus_1')"
                value="1"
              />

              <el-option
                :label="$t('showMerbankaccount.checkStatus_2')"
                value="2"
              />
            </el-select>
          </el-form-item>

          <el-form-item
            :label="$t('MerBankAccount.mbaCheckReason')"
          >
            <el-input
              v-model="checkForm.reason"
              type="textarea"
              :rows="3"
            />
          </el-form-item>

        </template>

      </el-form>


      <div class="drawer-footer">
        <el-button @click="updateDialogVisible = false">
          {{$t('cancel')}}
        </el-button>

        <el-button
          v-if="dialogType === 'check'"
          type="primary"
          @click="submitCheck"
        >
          {{ $t('sure') }}
        </el-button>

        <el-button
          v-else
          type="primary"
          :loading="updateLoading"
          @click="submitForm"
        >
          {{ $t('sure') }}
        </el-button>


      </div>

    </el-drawer>
  </div>




</template>

<script>
import { hasPermission } from "@/utils/permission";
export default {
  name: "OrderList",
  data() {
    return {
      loading: false,
      MerBankAccount: {
        startDate: "",
        endDate: "",
        hkbatchNo: "",

        sortField: undefined,
        sortOrder: undefined
      },
      selectedRowData:"",// 当前行全部数据
      selectedRowId:"",// 选择id
      moreDialogVisible: false,
      moreInput: '',          // 弹窗中的文本内容
      currentField: null,     // 当前正在编辑的字段名，如 'orderNo'
      hasSearched: false,   //  是否有进行查询

      updateDialogVisible: false,//弹窗
      dialogType: '',
      dialogTitle:"",
      currencyList: [],

      checkAllCurrency: false,
      // 弹窗字段
      formData: {
        mbaId:"",
        mbaBankname: '',
        mbaBankholder: '',
        mbaBankaccount: '',
        province: '',
        city: '',
        mbaBandadd: '',
        mbaBankCountry: '',

        mbaCurrency: [],

        mbaPayeeProperty: '',
        mbaPayeeAddress: '',
        mbaPayeeCountry: '',

        mbaMiddleBank: '',
        mbaMiddleBankcode: '',

        mbaSwiftCode: '',
        mbaIban: '',
        mbaPayBank: '',

        mbaRemark: ''
      },
      checkForm: {
        status: '', // 1通过 2拒绝
        reason: ''
      },
      handleDrawerClose(done) {

        this.formData = {
          mbaId:"",
          mbaBankname:"",
          mbaBankholder:"",
          mbaBankaccount:"",
          province:"",
          city:"",
          mbaBandadd:"",
          mbaBankCountry:"",
          mbaCurrency:[],
          mbaPayeeProperty:"",
          mbaPayeeAddress:"",
          mbaPayeeCountry:"",
          mbaMiddleBank:"",
          mbaMiddleBankcode:"",
          mbaSwiftCode:"",
          mbaIban:"",
          mbaPayBank:"",
          mbaRemark:""
        };

        this.checkAllCurrency = false;

        done();
      },
      updateLoading: false,
      tableData: [],

      columnWidths:{},
      pagination: {
        page: 1,
        limit: 10,
        total: 0,
      },
      pages:"",

    };
  },
  created() {
    // this.handleSearch(); // 初始化加载数据
  },
  mounted() {
    this.$nextTick(() => {
      this.initColumnWidths();
    });
  },
  // 发送变化重新计算
  computed:{
    rules() {
      //弹窗校验
      return  {
        /*开户银行*/
        mbaBankname: [
          { required: true, min: 2, max: 100, message: this.$t('showMerbankaccount.mbaBankname_iv_oe'), trigger: 'blur' }
        ],
          /*开户用户名*/
          mbaBankholder: [
          /* { required: true, message: '请输入开户用户名', trigger: 'blur' }*/
          { required: true, min: 2, max: 100, message: this.$t('showMerbankaccount.mbaBankholder_iv_oe'), trigger: 'blur' }
        ],
          /*开户账号*/
          mbaBankaccount: [
          /*{ required: true, message: '请输入开户账号', trigger: 'blur' }*/
          { required: true, min: 2, max: 100, message: this.$t('showMerbankaccount.mbaBankaccount_iv_oe'), trigger: 'blur' }

        ],
          /*province*/
          province:[
          { max: 50, message: this.$t('showMerbankaccount.merState_fv_of'), trigger: 'blur' }
        ],

          /*city*/
          city:[
          {  max: 50, message: this.$t('showMerbankaccount.merCity_fv_of'), trigger: 'blur' }
        ],

          /*开户银行地址*/
          mbaBandadd: [
          /*{ required: true, message: '请输入开户银行地址', trigger: 'blur' }*/
          { required: true, min: 2, max: 100, message: this.$t('showMerbankaccount.mbaBandadd_fv_of'), trigger: 'blur' }
        ],
          /*开户行地址国别*/
          mbaBankCountry: [
          /* { required: true, message: '请输入开户行地址国别', trigger: 'blur' }*/
          { required: true, min: 1, max: 100, message: this.$t('showMerbankaccount.mbaBankCountry_fv_of'), trigger: 'blur' }
        ],
          /*支持币种*/
          mbaCurrency: [
          /*{ type: 'array', required: true, message: '请至少选择一个支持币种', trigger: 'change' }*/
          { type: 'array', required: true, message: this.$t('showMerbankaccount.mbaBankcurrency_fv_of'), trigger: 'change' }
        ],
          /*收款人属性*/
          mbaPayeeProperty: [
          /*  { required: true, message: '请输入收款人属性', trigger: 'blur' }*/
          { required: true, min: 1, max: 100, message: this.$t('showMerbankaccount.mbaPayeeProperty_fv_of'), trigger: 'blur' }
        ],
          /*收款人地址*/
          mbaPayeeAddress: [
          /* { required: true, message: '请输入收款人地址', trigger: 'blur' }*/
          { required: true, min: 1, max: 100, message: this.$t('showMerbankaccount.mbaPayeeAddress_fv_of'), trigger: 'blur' }
        ],
          /*收款人地址国别*/
          mbaPayeeCountry: [
          /* { required: true, message: '请输入收款人地址国别', trigger: 'blur' }*/
          { required: true, min: 1, max: 100, message: this.$t('showMerbankaccount.mbaPayeeCountry_fv_of'), trigger: 'blur' }

        ],
          /*中间行*/
          mbaMiddleBank:[
          {  max: 100, message: this.$t('showMerbankaccount.mbaMiddleBank_fv_of'), trigger: 'blur' }
        ],
          /*中间行代码*/
          mbaMiddleBankcode:[
          {  max: 100, message: this.$t('showMerbankaccount.mbaMiddleBankcode_fv_of'), trigger: 'blur' }
        ],
          /*SWIFT CODE*/
          mbaSwiftCode: [
          /* { required: true, message: '请输入SWIFT CODE', trigger: 'blur' }*/
          { required: true, min: 1, max: 100, message: this.$t('showMerbankaccount.mbaSwiftCode_fv_of'), trigger: 'blur' }
        ],
          /*IBAN*/
          mbaIban:[
          { max: 100, message: this.$t('showMerbankaccount.mbaIban_fv_of'), trigger: 'blur' }
        ],
          /*打款银行*/
          mbaPayBank:[
          {  max: 100, message: this.$t('showMerbankaccount.mbaPayBank_fv_of'), trigger: 'blur' }
        ],
          mbaRemark:[
          {  max: 500, message: this.$t('showMerbankaccount.remark_fv_of'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    // 按钮
    hasPermission,
    // 排序
    handleSortChange({ column, prop, order }) {
      // prop 是排序的字段名 (例如 'tsId')
      // order 是排序方式：'ascending' (升序), 'descending' (降序), 或者 null (默认不排序)
      if (order === null) {
        this.MerBankAccount.sortField = undefined;
        this.MerBankAccount.sortOrder = undefined;
      } else {
        // 正常赋值升序或降序
        this.MerBankAccount.sortField = prop;
        this.MerBankAccount.sortOrder = order;
      }

      // 重新调用获取列表的接口
      this.fetchOrderList();
    },
    // 数据绑定
    handleRadioChange(row) {
      this.selectedRowData = row;
    },


    // 查询
    handleSearch() {
      this.pagination.page = 1; // 重置页码
      this.fetchOrderList();
    },
    // 重置
    handleReset() {
      this.$refs.queryForm.resetFields();

      this.hasSearched = false;
      //this.handleSearch();
    },
    //
    async fetchOrderList() {
      this.loading = true;
      try {
        const params = {
          mbaBankaccount: this.MerBankAccount.mbaBankaccount || undefined,
          mbaStatus: this.MerBankAccount.mbaStatus || undefined,

          sortField: this.MerBankAccount.sortField || undefined,
          sortOrder: this.MerBankAccount.sortOrder || undefined,

          page: this.pagination.page,
          limit: this.pagination.limit,
        };

        const res = await this.$axios.post('/api/bankAccount/merlist',  params );

        if (res.data.code === 0) {
          const responseData = res.data.data;

          this.tableData = responseData.records || [];

          this.pagination.total = Number(responseData.total) || 0;
          this.pagination.page = Number(responseData.current) || this.pagination.page;
          this.pagination.limit = Number(responseData.size) || this.pagination.limit;

          if (this.pagination.total > 0) {
            this.hasSearched = true;
          }
        } else {
          this.$message.error(res.data.msg);
          this.tableData = [];
          this.pagination.total = 0;
        }
      } catch (err) {
        console.error('查询订单失败:', err);
        this.$message.error(this.$t('requestFailed'));
        this.tableData = [];
        this.pagination.total = 0;
      } finally {
        this.loading = false;
      }
    },

    // 分页：每页条数变化
    handleSizeChange(val) {
      this.pagination.limit = val;
      this.pagination.page = 1; //
      this.fetchOrderList(); //
    },
    // 分页：当前页变化
    handleCurrentChange(val) {
      this.pagination.page = val;
      this.fetchOrderList(); //
    },
    // 处理选择id
    handleRowClick(row) {
      this.selectedRowId = row.tsId;

    },
    async handleUpdate() {

      if (!this.selectedRowData) {
        this.$message.warning(this.$t('alert_select'));
        return;
      }

      if (String(this.selectedRowData.mbaStatus) !== '2') {
        this.$message.warning(this.$t('showMerbankaccount.alert_modify_normal'));
        return;
      }

      var newVar = await this.checkBankAccountExistHaveType();
      if(newVar === true){
        this.$message.warning(this.$t('showMerbankaccount.mba_update_exists') );
        return;
      }

      try {

        await this.loadCurrencyList();

        this.dialogType = 'update';
        this.dialogTitle = this.$t('showMerbankaccount.merbankaccount_update');

        const rawCurrency = this.selectedRowData.mbaCurrency || '';
        const currencyArr = rawCurrency
          ? rawCurrency.split(',').map(i => String(i).trim()).filter(Boolean)
          : [];

        this.formData = {
          ...this.selectedRowData,
          mbaCurrency: currencyArr
        }

        this.checkAllCurrency =
          this.formData.mbaCurrency.length === this.currencyList.length

        this.updateDialogVisible = true;

      } catch (e) {

        console.error(e);

        this.$message.error(  $t('loginPage.serverError') );

      }
    },
    async handleAdd() {

      try {

        await this.loadCurrencyList();

        this.dialogType = 'add';
        this.dialogTitle = this.$t('showMerbankaccount.merbankaccount_add');

        this.resetForm();

        this.updateDialogVisible = true;

      } catch (e) {

        console.error(e);

        this.$message.error(  $t('loginPage.serverError') );

      }
    },
    async handleDele(){
      // 未选择数据
      if (!this.selectedRowData) {
        this.$message.warning(this.$t('alert_select'));
        return;
      }

      if (String(this.selectedRowData.mbaStatus) === '2' && String(this.selectedRowData.mbaIsdefault) === '1') {
        this.$message.warning(this.$t('showMerbankaccount.alert_delete_normal'));
        return;
      }
      try {
        await this.$confirm(
          this.$t('showMerbankaccount.alert_del_role'),
          this.$t('tips'),
          {
            confirmButtonText: this.$t('sure'),
            cancelButtonText: this.$t('cancel'),
            type: 'warning'
          }
        );
        const res = await this.$axios.delete(
          `/api/bankAccount/delete/${this.selectedRowData.mbaId}`
        );

        if (res.data.code === 0) {

          this.$message.success(this.$t('succeed'));

          this.selectedRowData = null;
          this.selectedRowId = null;

          this.fetchOrderList();

        } else {

          this.$message.error(res.data.msg);

        }

      }catch (e){
        // 用户点击取消
        if (e !== 'cancel') {
          console.error(e);
          this.$message.error(this.$t('delete_fail'));
        }
      }
    },
    async handleCheck(){
      // 未选择数据
      if (!this.selectedRowData) {
        this.$message.warning(this.$t('alert_select'));
        return;
      }
      if (String(this.selectedRowData.mbaStatus) !== '0'){
        this.$message.warning(this.$t('showMerbankaccount.alert_check_normal'));
        return;
      }
      const currentUser = sessionStorage.getItem('user');
      if(String(this.selectedRowData.mbaLoginName) === String(currentUser)){
        this.$message.warning(
          this.$t('showMerbankaccount.mba_checkuserissame')
        );
        return;
      }

      this.dialogType = 'check';
      this.dialogTitle =
        this.$t('showMerbankaccount.merbankaccount_check');
      this.formData = {
        ...this.selectedRowData
      };
      this.checkForm = {
        status: '',
        reason: ''
      };

      this.updateDialogVisible = true;

    },

    // 获取银行账单币种
    async loadCurrencyList() {
      const res = await this.$axios.get('/api/currency/getlist');
      this.currencyList = res.data.data || []
    },
    // 币种全选
    handleCheckAllCurrency(val) {

      if (val) {

        this.formData.mbaCurrency =
          this.currencyList.map(item => item.currValue)

      } else {

        this.formData.mbaCurrency = []
      }
    },
    // 弹窗提交
    submitForm() {

      this.$refs.form.validate(async (valid) => {
        if (!valid) return;

        const isExist = await this.checkBankAccountExist();

        if (isExist) {
          this.$message.warning(this.$t('showMerbankaccount.mbaBankaccount_ajax'));
          this.updateLoading = false; // 关闭 loading
          return; // 拦截，不再向下执行提交逻辑
        }

        if (this.dialogType === 'add') {
          this.handleCreate();
        } else {
          this.handleUpdateSubmit();
        }
      });
      //this.updateDialogVisible = false;
    },
    // 新增
    async handleCreate() {
      try {

        this.updateLoading = true;

        const params = {
          ...this.formData,

          mbaCurrency: this.formData.mbaCurrency
            ? this.formData.mbaCurrency.join(',')
            : ''
        };

        const res = await this.$axios.post(
          '/api/bankAccount/add',
          params
        );

        if (res.data.code === 0) {
          this.$message.success(this.$t('succeed'));

          this.updateDialogVisible = false;

          this.fetchOrderList();

          // 清空表单
          this.resetForm();

        } else {
          this.$message.error(res.data.msg || this.$t('addError'));
        }

      } catch (e) {
        console.error(e);
        this.$message.error(this.$t('addError'));
      } finally {
        this.updateLoading = false;
      }
    },
    // 修改
    async handleUpdateSubmit() {
      try {
        const params = {
          ...this.formData,

          mbaCurrency: this.formData.mbaCurrency
            ? this.formData.mbaCurrency.join(',')
            : ''
        };
        const res = await this.$axios.put('/api/bankAccount/update', params);

        if (res.data.code === 0) {
          this.$message.success(this.$t('updaSucceed'));
          this.updateDialogVisible = false;
          this.fetchOrderList();
        } else {
          this.$message.error(res.data.msg);
        }

      } catch (e) {
        console.error(e);
        this.$message.error(this.$t('updaError'));
      }
    },
    // 开户账号判断  当打开修改的时候需要type传入数据进行判断
    async checkBankAccountExist() {
      try {
        // 组装传给后端的参数
        const params = {
          bankaccount: this.formData.mbaBankaccount,
          type:"",
        };

        // 修改穿id
        if (this.dialogType === 'update' && this.formData.mbaId) {
          params.id = String(this.formData.mbaId);
        }

        const res = await this.$axios.get('/api/bankAccount/existence', { params });

        const existFlag = res.data.data !== undefined ? res.data.data : res.data;

        return existFlag === true;

      } catch (error) {
        console.error('账号唯一性校验接口异常:', error);
        this.$message.error(this.$t('requestFailed'));
        // 如果接口挂了，为了数据安全，默认返回 true 阻止表单提交
        return true;
      }
    },
    async checkBankAccountExistHaveType() {
      try {
        // 组装传给后端的参数
        const params = {
          bankaccount: this.formData.mbaBankaccount,
          type:"1",
        };

        // 修改穿id
        if (this.dialogType === 'update' && this.formData.mbaId) {
          params.id = String(this.formData.mbaId);
        }

        const res = await this.$axios.get('/api/bankAccount/existence', { params });

        const existFlag = res.data.data !== undefined ? res.data.data : res.data;

        return existFlag === true;

      } catch (error) {
        console.error('账号唯一性校验接口异常:', error);
        this.$message.error(this.$t('requestFailed'));
        // 如果接口挂了，为了数据安全，默认返回 true 阻止表单提交
        return true;
      }
    },
    // 审核
    async submitCheck() {

      if (!this.checkForm.status) {
        this.$message.warning(
          this.$t('showMerbankaccount.mbaStatus_iv_oe')
        );
        return;
      }


      try {
        const params = {
          id: this.formData.mbaId,
          status: this.checkForm.status,
          reason: this.checkForm.reason
        };

        const res = await this.$axios.put(
          '/api/bankAccount/confirm',
          params
        );

        if (res.data.code === 0) {

          this.$message.success(this.$t('succeed'));

          this.updateDialogVisible = false;

          this.fetchOrderList();

        } else {

          this.$message.error(res.data.msg);

        }

      } catch (e) {

        console.error(e);

        this.$message.error(this.$t('failed'));

      }
    },
    resetForm() {
      this.formData = {
        mbaBankname: '',
        mbaBankholder: '',
        mbaBankaccount: '',
        province: '',
        city: '',
        mbaBandadd: '',
        mbaBankCountry: '',
        mbaCurrency: [],
        mbaPayeeProperty: '',
        mbaPayeeAddress: '',
        mbaPayeeCountry: '',
        mbaMiddleBank: '',
        mbaMiddleBankcode: '',
        mbaSwiftCode: '',
        mbaIban: '',
        mbaPayBank: '',
        mbaRemark: ''
      };

      this.checkAllCurrency = false;

      // 清空选中行
      this.selectedRowData = null;
      this.selectedRowId = null;
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate();
      });
    },



    // 表头宽度
    initColumnWidths() {
      const cols = [
        "mbaBankname",
        'mbaBankholder',
        'mbaBankaccount',
        'mbaBandadd',
        'mbaBankCountry',
        'mbaCurrency',
        'mbaIsdefault',
        'mbaStatus',
        'mbaCheckUser',
        'mbaCheckTime',
        'mbaCheckReason',
        'loginName',
        'oprtime',
        'remark',

      ];
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      ctx.font = '14px Helvetica';

      cols.forEach(key => {
        const label = this.$t(
          `MerBankAccount.${key}`
        );

        this.$set(
          this.columnWidths,
          key,
          Math.ceil(ctx.measureText(label).width) + 50
        );
      });
    }
  },
};
</script>

<style>
/* 全局样式 - 表头居中 */
.el-table th .cell {
  white-space: nowrap !important;
  text-align: center !important;
}

.el-table .cell {
  white-space: nowrap !important;
  text-align: center !important;
}
</style>

<style scoped>
.order-list {
  padding: 20px;
}

/* 确保输入框、下拉框、时间选择器在栅格中占满 100% 宽度 */
.full-width {
  width: 100% !important;
}

/* 使用 Flex 布局优雅处理 输入框 + More 按钮 的组合 */
.input-with-more {
  display: flex;
  align-items: center;
  width: 100%;
}

.input-with-more .el-input {
  flex: 1; /* 让输入框自动撑满剩余空间 */
}

.input-with-more .el-button {
  margin-left: 10px; /* 按钮和输入框之间的间距 */
  flex-shrink: 0; /* 防止按钮被挤压变形 */
}

/* 保持表格原有样式不变 */
.table-card ::v-deep .el-table .cell {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
.table-card ::v-deep .el-table th .cell {
  white-space: nowrap !important;
}
.table-card {
  overflow-x: auto;
}

.table-card ::v-deep .el-table {
  min-width: 100%;
}


/* --- 修改 1：美化查询表单的标签字体 --- */
.query-card /deep/ .el-form-item__label {
  white-space: nowrap !important;
  font-weight: 600 !important; /* 强制加粗生效 */
  color: #303133 !important; /* 强制颜色深灰生效 */
  font-size: 14px !important;
  letter-spacing: 0.5px !important;
  min-width: 140px;
  text-align: right;
}

/* --- 修改 2：美化输入框内的字体和边框 --- */
.query-card /deep/ .el-input__inner {
  font-weight: 500 !important; /* 强制生效 */
  color: #606266 !important; /* 强制生效 */
  border-radius: 6px !important; /* 强制微圆角生效 */
}
/* 鼠标悬浮时输入框边框颜色加深一点点（可选增亮效果） */
.query-card /deep/ .el-input__inner:hover {
  border-color: #c0c4cc !important;
}

/* 操作工具栏样式 */
.action-toolbar {
  margin-top: 16px;     /* 与上方查询卡片拉开间距 */
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

/* 按钮之间的间距调整 */
.action-toolbar .el-button {
  margin-left: 10px;
  margin-right: 0;
}

.drawer-form {
  padding-right: 20px;
}

/*侧边弹窗*/
.drawer-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;

  padding: 15px 20px;

  border-top: 1px solid #ebeef5;
  background: #fff;

  text-align: right;
}
::v-deep .el-drawer__body {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}
.drawer-form {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  padding-bottom: 80px;
}
.drawer-footer {
   flex-shrink: 0;
   padding: 15px 20px;
   border-top: 1px solid #ebeef5;
   background: #fff;
   text-align: right;
 }

</style>



// WEBPACK FOOTER //
// src/view/merchant/showMerbankaccount.vue